import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { SamparkEolApiService } from '../CommonController/sampark-eol-api-service';

@Component({
  selector: 'app-sampark-eol-page',
  templateUrl: './sampark-eol-page.component.html',
  styleUrls: ['./sampark-eol-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class SamparkEolPageComponent implements OnInit {
  // Pagination settings
  pageSize = 10;
  currentPage = 1;
  totalItems = 0;
  searchText = '';
  samparkEolDeviceList: any[] = [];

  accountOptions = [
    { label: 'Sampark 4G CAN', value: 35 },
    { label: 'Sampark 4G', value: 46 },
  ];

  samparkEolForm!: FormGroup;

  userPermission = [];
  loggedId = '';
  samparkEolDeviceView = false;
  samparkEolDeviceUpdate = false;
  samparkEolDeviceCreate = false;
  samparkEolDeviceDelete = false;

  constructor(
    public samparkEolApiService: SamparkEolApiService,
    public commonApiService: CommonApiService,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.fetchSamparkEolDeviceList();
  }

  checkPermission() {
    this.loggedId = sessionStorage.getItem('loggedInUserId') || '';
    this.userPermission = JSON.parse(
      sessionStorage.getItem('userPermissions') || '[]'
    );
    this.userPermission.forEach((element: any) => {
      if (element.pageName === 'Sampark EOL' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Sampark EOL' && element.view === true) {
        this.samparkEolDeviceView = true;
      }
      if (element.pageName === 'Sampark EOL' && element.update === true) {
        this.samparkEolDeviceUpdate = true;
      }
      if (element.pageName === 'Sampark EOL' && element.create === true) {
        this.samparkEolDeviceCreate = true;
      }
      if (element.pageName === 'Sampark EOL' && element.delete === true) {
        this.samparkEolDeviceDelete = true;
      }
    });
  }

  fetchSamparkEolDeviceList() {
    this.spinner.show();
    this.samparkEolApiService
      .getSamparkEolDeviceList(this.currentPage, this.pageSize, this.searchText)
      .subscribe({
        next: (res) => {
          this.samparkEolDeviceList = res.data;
          this.totalItems = res.totalItems;
          this.commonApiService.openSnackbar(res.message);
          this.spinner.hide();
        },
        error: (error) => {
          this.samparkEolDeviceList = []; // Clear the list
          this.totalItems = 0; // Reset the total count
          this.currentPage = 1;
          this.spinner.hide();
          this.commonApiService.openSnackbar(
            error.error.message || 'An error occurred while fetching data.'
          );
        },
      });
  }

  uploadToTml(imei: string) {
    this.spinner.show();

    this.samparkEolApiService.uploadToTml(imei).subscribe({
      next: (res) => {
        this.commonApiService.openSnackbar(res.message);

        // Refresh the table so Upload Status becomes "Uploaded"
        this.fetchSamparkEolDeviceList();

        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        this.commonApiService.openSnackbar(
          error.error?.message || 'Failed to upload device to TML.'
        );
      },
    });
  }

  prepopulation(imei: string) {
    this.router.navigate(['sampark-eol-device-add-page', imei]);
  }

  delete(imei: string) {
    const userId = this.loggedId; // Hardcoded userId
    if (confirm('Are you Sure?')) {
      this.spinner.show();
      this.samparkEolApiService
        .deleteSamparkEolData(imei, userId)
        .subscribe((res) => {
          if (res.status) {
            this.commonApiService.openSnackbar(res.message);
          } else {
            this.commonApiService.openSnackbar(res.message);
          }
          this.fetchSamparkEolDeviceList(); // Refresh list after deletion
          this.spinner.hide();
        });
    }
  }

  AddNew() {
    this.router.navigate(['sampark-eol-device-add-page']);
  }

  onPageChange(event: any) {
    this.currentPage = event;
    this.fetchSamparkEolDeviceList();
  }

  onSearchInputChange(event: any) {
    this.currentPage = 1;
    this.searchText = event;
    this.fetchSamparkEolDeviceList();
  }

  onSizeChange(newSize: any): void {
    this.pageSize = newSize; // Update the pageSize
    this.currentPage = 1; // Reset to the first currentPage
    this.fetchSamparkEolDeviceList();
  }

  redirect(to: any): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.commonApiService.back();
  }

  getAccountLabelById(accountId: number | string | null): string {
    if (!accountId) return '';
    const numId = typeof accountId === 'string' ? Number(accountId) : accountId;
    const account = this.accountOptions.find((opt) => opt.value === numId);
    return account ? account.label : '';
  }
}
